import React from "react";
import { Link } from "react-router-dom";
import { useCurrentUser } from "./useCurrentUser";
import UserDropdown from "./UserDropdown";

const Auth = () => {
  const { isLoading, isAuthenticated } = useCurrentUser();

  if (isLoading)
    return (
      <div className="hidden gap-3 sm:flex">
        <div className=" h-8 w-20 animate-pulse rounded-md bg-gray-300"></div>
        <div className=" h-8 w-20 animate-pulse rounded-md bg-gray-300"></div>
      </div>
    );

  return (
    <div className=" hidden items-center gap-2 md:flex">
      {isAuthenticated && !isLoading ? (
        <UserDropdown />
      ) : (
        <>
          <Link
            className=" rounded-md bg-gray-300 px-4 py-1.5 font-semibold capitalize text-stone-600 transition-all duration-300 dark:btn-neutral  hover:shadow-xl dark:bg-gray-300 dark:bg-none dark:text-stone-600 dark:hover:border-gray-400 dark:hover:text-gray-300 dark:hover:shadow-shadowOne"
            to={"login"}
          >
            Login
          </Link>
          <Link
            className=" rounded-md bg-sky-500 px-4 py-1.5 font-semibold capitalize text-stone-200 transition-all duration-300 dark:btn-neutral  hover:shadow-xl dark:bg-gray-300 dark:bg-none dark:text-stone-600 dark:hover:border-gray-400 dark:hover:text-gray-300 dark:hover:shadow-shadowOne"
            to={"register"}
          >
            signup
          </Link>
        </>
      )}
    </div>
  );
};

export default Auth;
